import { Box, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
// import moment from 'moment';
// import 'moment/locale/pt'
import { format, parseISO } from 'date-fns'; // without this line it didn't work
import React from 'react';

import ReportDetailsItem from './ReportDetailsItem';
import ReportGraph from './ReportGraph';

const useStyles = makeStyles((theme) => ({
  text: {
    fontSize: 18,
    textAlign: 'left',
  },
}));

export default function ReportDetails(props) {
  // moment.locale('pt')
  const classes = useStyles();
  const survival = (
    ((parseInt(props.details.actual_population || 0) +
      parseInt(props.details.sum_transfer_exit || 0)) *
      100) /
    (props.details.input_population || 1)
  ).toFixed(2);
  return (
    <Grid
      container
      justifyContent="space-around"
      alignItems="center"
      // style={{ padding: '.5rem' }}
    >
      <Grid item xs={3} className={classes.text}>
        <Box border={0}>
          {/* <ReportDetailsItem title='Lote' value={props.details.lot || 'N/A'} /> */}
          <ReportDetailsItem
            title="Status"
            value={String(props.details.status)}
          />
          <ReportDetailsItem
            title="FCA"
            value={
              !(props.details.fca === 0 || props.details.fca === null)
                ? parseFloat(props.details.fca).toFixed(2)
                : 0
            }
          />
          <ReportDetailsItem
            title="Dias de cultivo"
            value={props.details.cultivation_days || 0}
          />
          <div
            style={{
              marginTop: '1rem',
            }}
          />
          <ReportDetailsItem
            title="Entradas via transferência"
            value={props.details.sum_transfer_entrance || 0}
          />
          <ReportDetailsItem
            title="Saídas via transferência"
            value={props.details.sum_transfer_exit || 0}
          />
          <div
            style={{
              marginTop: '1rem',
            }}
          />
          <ReportDetailsItem
            title="Data de entrada"
            value={
              props.details.begin
                ? format(
                    parseISO(props.details.begin.substring(0, 10)),
                    'dd/MM/yyyy'
                  )
                : 'Não cadastrada'
            }
          />
          <ReportDetailsItem
            title="Data de saída"
            value={
              props.details.end
                ? format(
                    parseISO(props.details.end.substring(0, 10)),
                    'dd/MM/yyyy'
                  )
                : 'Não cadastrada'
            }
          />
          <div
            style={{
              marginTop: '1rem',
            }}
          />
          <ReportDetailsItem
            title="Ganho de biomassa"
            value={
              props.details.biomass_gain !== 0 ||
              props.details.biomass_gain === null
                ? props.details.biomass_gain.toFixed(2)
                : `${0} Kg (${props.details.biomass_gain_percentage}` !== 0 ||
                  props.details.biomass_gain_percentage === null
                ? 0
                : `${props.details.biomass_gain_percentage.toFixed(2)}%)`
            }
          />

          <ReportDetailsItem
            title="Biomassa inicial"
            value={`${props.details.initial_biomass?.toFixed(2)} Kg`}
          />
          <ReportDetailsItem
            title="Biomassa final/atual"
            value={`${props.details.biomass?.toFixed(2)} Kg`}
          />
          <div
            style={{
              marginTop: '1rem',
            }}
          />
          <ReportDetailsItem
            title="População inicial"
            value={props.details.input_population || 'N/A'}
          />
          <ReportDetailsItem
            title="População final/atual"
            value={props.details.actual_population}
          />
        </Box>
      </Grid>
      <Grid item spacing={2}>
        <ReportGraph
          data={[
            { name: 'Sobrevivência', value: parseFloat(survival) },
            { name: 'Mortalidade', value: parseFloat(100 - survival) },
          ]}
        />
      </Grid>
    </Grid>
  );
}
